import { Check, X } from "lucide-react";
import { passwordRequirements } from "@/lib/passwordValidation";

interface PasswordRequirementsProps {
  password: string;
}

export function PasswordRequirements({ password }: PasswordRequirementsProps) {
  const requirements = [
    {
      label: "At least 8 characters",
      met: password.length >= passwordRequirements.minLength,
    },
    {
      label: "One uppercase letter",
      met: passwordRequirements.patterns.uppercase.test(password),
    },
    {
      label: "One lowercase letter",
      met: passwordRequirements.patterns.lowercase.test(password),
    },
    {
      label: "One number",
      met: passwordRequirements.patterns.number.test(password),
    },
    {
      label: "One special character (!@#$%^&*)",
      met: passwordRequirements.patterns.special.test(password),
    },
  ];

  return (
    <div className="space-y-1 text-sm">
      {requirements.map((req, index) => (
        <div
          key={index}
          className={`flex items-center gap-2 transition-colors ${
            req.met ? "text-green-600" : "text-muted-foreground"
          }`}
        >
          {req.met ? (
            <Check className="h-4 w-4" />
          ) : (
            <X className="h-4 w-4" />
          )}
          <span>{req.label}</span>
        </div>
      ))}
    </div>
  );
}
